export default __webpack_public_path__ + "static/RachaelNewsham-cbf1031764aa9a6cb09655a7e1182ead.png";